//
//

import { mapMutations, mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
import DashboardSettings from "@/assets/images/Buttons/DashboardSettings.svg";
import tasksStatus from "@/components/Dashboard/tasksStatusWidget.vue";
import productivityChart from "@/components/Dashboard/productivityChart/ProductivityChart.vue";
import RolesUsersTable from "@/components/Admin/RolesAndUsers/RolesAndUsersTable/rolesAndUsersTable.vue";
import allTasksComponent from "@/components/tasks/myTeamsTasks/allTasksComponent.vue";
import applicationsPage from "@/components/apps/applicationsPage/applicationsPage.vue";
import QFabricSelect from "@/components/q-fabric-select.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";

export default {
    components: {
        draggable,
        QFabricSelect,
        tasksStatus,
        RolesUsersTable,
        productivityChart,
        allTasksComponent,
        applicationsPage,
        AQDropdown,
        AQCard,
        AQButton,
        AQCheckbox,
        AQRadio,
        AQTooltip
    },
    beforeRouteUpdate(to, from, next) {
        if (this.dropdownIsOpen) {
            this.updateTaskList = true;
        }
        next();
    },
    data() {
        return {
            pageName: "Dashboard",
            userId: "",
            isManager: true,
            hideDropdown: true,
            dashboardType: "user",
            groupList: [],
            resetFilters: false,
            resetTaskSelectedValues: false,
            groupIdToSend: "",
            ddlGroups: [],
            ddlDefaultValue: "",
            selectedGroup: "",
            firstActivated: true,
            counter: 0,
            prodKey: 0,
            showTaskInstance: true,
            dropdownIsOpen: false,
            updateTaskList: false,
            dashboardSettingsIcon: `img:${DashboardSettings}`,
            dashboardItems: [
                {
                    name: "tasks",
                    visible: true,
                    disabled: false,
                    childOptions: [
                        {
                            name: "overview",
                            visible: false,
                            disabled: false
                        },
                        {
                            name: "tasklist",
                            visible: false,
                            disabled: false
                        }
                    ]
                }
            ],
            dashboardCheckboxModel: [],
            taskCheckboxModel: [],
            drag: false,
            settingsBtns: [
                { name: "dataTable.btnCancel", type: "cancel", color: "outline" },
                { name: "dataTable.btnReset", type: "reset", color: "outline" },
                { name: "dataTable.btnConfirm", type: "confirm", color: "primary" }
            ],
            tasksSuboptionsDisabled: false,
            hideOverview: false,
            hideTasklist: false,
            applyTo: "this",
            initialDashboardItems: [],
            draggableKey: 0,
            removeRouteQuery: false
        };
    },
    computed: {
        ...mapGetters("userProfile", ["userCookieInfo"]),
        ...mapGetters("userProfile", ["getUserIsManager", "getUserId"]),
        ...mapGetters("tasks", ["getSelectedTasksFilter"]),
        currentGroup() {
            let result = { id: "", name: "" };
            if (this.groupList.length > 0) {
                result = this.groupList.find(
                    item => item.id === this.getSelectedTasksFilter.groupId
                );
            }
            if (result && result.id) {
                const isMyTeamDashboard = localStorage.getItem("isMyTeamDashboard");
                if (isMyTeamDashboard === "true") {
                    this.goToTeamDashboard();
                }
            }

            return result;
        },
        orderedComponents() {
            const componentsOrder = [];
            this.dashboardItems.forEach(el => {
                componentsOrder.push(el.name);
            });
            return componentsOrder;
        },
        dashbordTeamProps() {
            return {
                dataList: this.groupList,
                selectFirstOption: true,
                hideCheckbox: true,
                closeOnSelection: true,
                hideClearDataIcon: true,
                keepOneOptionSelected: true
            };
        }
    },
    watch: {
        $route: {
            handler(newValue, oldValue) {
                if (newValue.name !== oldValue?.name && ["myteamsdashboard", "mydashboard"].includes(newValue.name)) {
                    this.counter++;
                    this.dashboardType = newValue.name === "myteamsdashboard" ? "team" : "user";
                }
            }
        }
    },
    created() {
        const vm = this;
        this.$store.commit("dashboard/setActive", true);
        this.$router.beforeEach((to, from, next) => {
            if (to.name === "dashboard") {
                vm.$store.commit("dashboard/setActive", true);
            }
            if (from.name === "dashboard") {
                vm.$store.commit("dashboard/setActive", false);
            }
            next();
        });
        this.$root.$on("teamsDashboard", state => {
            if (state) {
                const [firstGroup] = this.groupList;
                if (this.ddlDefaultValue && firstGroup) {
                    this.ddlDefaultValue = firstGroup.id;
                }
                this.goToTeamDashboard(true);
            } else {
                this.goToMyDashboard(true);
            }
        });

        this.dashboardType = this.$route.name === "myteamsdashboard" ? "team" : "user";
        if (this.dashboardType === "user") {
            this.dashboardItems.push({
                name: "applications",
                visible: true,
                disabled: false
            });
        } else {
            this.dashboardItems.push({
                name: "productivity",
                visible: true,
                disabled: false
            });
        }
        let localGroupId;
        if (this.dashboardType === "team") {
            this.getMyTeamGroups(this.getUserId).then(data => {
                localGroupId = data[0].id;
                this.getCustomization("TEAM_DASHBOARD", false, localGroupId);
            });
        } else {
            this.getCustomization("MY_DASHBOARD");
        }
    },
    activated() {
        if (this.firstActivated) {
            this.firstActivated = false;
        } else {
            this.counter++;
        }
        this.showTaskInstance = true;
        this.dashboardType = this.$route.name === "myteamsdashboard" ? "team" : "user";

        const triggerNoTaskPermission = sessionStorage.getItem("triggerNoTaskPermission");
        if (triggerNoTaskPermission) {
            sessionStorage.removeItem("triggerNoTaskPermission");
            this.$toast.showNotify({
                type: "warning",
                message: this.$t(`apps.${triggerNoTaskPermission}`)
            });
        }

        if (this.getUserIsManager) {
            this.getMyTeamGroups(this.getUserId).then(data => {
                this.groupList = data;
                this.groupList = this.groupList.filter(el => el.active);
                this.ddlGroups = this.groupList.map(group => ({ label: group.name, value: group.id }));
                const { query } = this.$route;
                this.ddlDefaultValue = (query?.groupId && this.ddlGroups.find(el => el.value === query.groupId))
                    ? query.groupId : this.ddlGroups[0].value;

                const storageExecutionData = window.localStorage.getItem("executionData");
                if (storageExecutionData) {
                    const storageData = storageExecutionData ? JSON.parse(storageExecutionData) : {};
                    const firstTime = !storageData.__dashboardInitCheck;

                    if (firstTime && storageData.__dashboard) {
                        this.$store.commit("tasks/setSelectedTasksFilter", {
                            groupId: storageData.__myTeamsFilters
                                ? storageData.__myTeamsFilters.groupId : null
                        });
                        this.dashboardType = storageData.__teamDashboard ? "team" : "user";
                        storageData.__dashboardInitCheck = true;
                        window.localStorage.setItem("executionData", JSON.stringify(storageData));
                    }
                } else {
                    this.$store.commit("tasks/setSelectedTasksFilter", { groupId: data[0].id });
                }
            });
        }
    },
    deactivated() {
        this.showTaskInstance = false;
        this.ddlDefaultValue = "";
    },
    beforeDestroy() {
        this.$root.$off("teamsDashboard");
    },
    methods: {
        ...mapActions("userProfile", ["getUserDetails"]),
        ...mapActions("tasks", ["getMyTeamGroups"]),
        ...mapActions("dashboard", [
            "getDashboardCustomization",
            "saveDashboardCustomization",
            "resetDashboardCustomization"
        ]),
        ...mapMutations("tasks", ["setSelectedTasksFilter"]),
        dashbordSelectGroups(groups) {
            this.groupIdToSend = groups[0].value;
            this.$store.commit("tasks/setSelectedTasksFilter", { groupId: groups[0].value });
            this.hideOverview = false;
            this.hideTasklist = false;
            if (this.groupIdToSend) {
                this.removeRouteQuery = true;
                this.getCustomization("TEAM_DASHBOARD");
            }
        },
        checkIfDropdownOpened(data) {
            this.dropdownIsOpen = data;
        },
        removeQueryOnRoute() {
            this.dashboardItems.forEach(item => {
                if (item.name === "tasks") {
                    const taskNotVisible = !item.visible || item.childOptions.find(el => el.name === "tasklist" && !el.visible);
                    const checkIfQuery = this.dashboardType === "team"
                        ? Object.keys(this.$route.query).length > 1 : Object.keys(this.$route.query).length;
                    if (checkIfQuery && taskNotVisible) {
                        this.resetFilters = true;
                        this.resetTaskSelectedValues = true;
                        const query = this.dashboardType === "team" ? { groupId: this.$route.query.groupId } : {};
                        this.$nextTick(() => {
                            this.$router.replace({ query });
                            this.resetFilters = false;
                            this.resetTaskSelectedValues = false;
                        });
                    }
                }
            });
        },
        goToTeamDashboard() {
            this.resetFilters = true;
            if (!this.groupIdToSend) {
                this.$store.commit("tasks/setSelectedTasksFilter", { groupId: this.groupList[0].id });
            }
            this.groupIdToSend = "";
            setTimeout(() => {
                this.resetFilters = false;
            }, 0);
            this.dashboardType = "team";
            localStorage.setItem("isMyTeamDashboard", true);
            this.getCustomization("TEAM_DASHBOARD", "team");
        },
        goToMyDashboard() {
            this.resetFilters = true;
            setTimeout(() => {
                this.resetFilters = false;
            }, 0);
            this.dashboardType = "user";
            localStorage.setItem("isMyTeamDashboard", false);
            this.getCustomization("MY_DASHBOARD", "user");
        },
        getCustomization(type, goTo, groupId, fromReset) {
            const payload = { type };
            if (type === "TEAM_DASHBOARD") {
                payload.groupId = this.getSelectedTasksFilter.groupId || groupId;
                if (!payload.groupId) {
                    return;
                }
            }
            this.getDashboardCustomization(payload).then(data => {
                this.setDashboardItems(JSON.parse(data.data.settings));
                this.initialDashboardItems = JSON.parse(JSON.stringify(this.dashboardItems));
                if (goTo === "user") {
                    this.dashboardType = "user";
                    localStorage.setItem("isMyTeamDashboard", false);
                } else if (goTo === "team") {
                    this.dashboardType = "team";
                    localStorage.setItem("isMyTeamDashboard", true);
                }
                this.updateSubtasksLogic();
                if (fromReset) {
                    this.tasksSuboptionsDisabled = false;
                    this.applyTo = data.data.applyToAll ? "all" : "this";
                }
                if (this.removeRouteQuery) {
                    this.removeRouteQuery = false;
                    this.removeQueryOnRoute();
                }
            });
        },
        triggerBtnAction(actionType) {
            switch (actionType) {
                case "confirm": {
                    this.saveCustomization(this.dashboardItems);
                    this.$refs.settingsPopoverRef.hide();
                    this.removeQueryOnRoute();
                    break;
                }
                case "reset": {
                    this.getDefaultCustomization(this.dashboardType);
                    this.$refs.settingsPopoverRef.hide();
                    break;
                }
                case "cancel": {
                    this.cancelBehavior(true);
                    this.$refs.settingsPopoverRef.hide();
                    break;
                }
                default:
                    this.$refs.settingsPopoverRef.hide();
            }
        },
        dragEnd() {
            this.drag = false;
        },
        optionClicked(ev, item) {
            if (item.name === "tasks") {
                this.tasksSuboptionsDisabled = !ev.includes("tasks");
            }
            if (ev.length === 1) {
                const disabledElem = this.dashboardItems.find(el => el.name === ev[0]);
                disabledElem.disabled = true;
            } else {
                this.dashboardItems.forEach(el => { el.disabled = false; });
                this.tasksSuboptionsDisabled = false;
            }
            const selectedItem = this.dashboardItems.find(el => el.name === item.name);
            if (selectedItem) selectedItem.visible = ev.includes(item.name);
        },
        showSection(section) {
            const sectionItem = this.dashboardItems.find(el => el.name === section);
            return !!sectionItem?.visible;
        },
        taskSuboptionClicked(ev, item) {
            const taskItem = this.dashboardItems.find(el => el.name === "tasks");
            taskItem.childOptions.find(el => el.name === item.name).visible = ev.includes(item.name);
            if (ev.length === 1) {
                const taskSubItem = taskItem.childOptions.find(el => el.name === ev[0]);
                taskSubItem.disabled = true;
                if (taskSubItem.name === "overview") {
                    this.hideTasklist = true;
                } else {
                    this.hideOverview = true;
                }
            } else {
                taskItem.childOptions.forEach(el => { el.disabled = false; });
                this.hideOverview = false;
                this.hideTasklist = false;
            }
        },
        saveCustomization(settings) {
            const type = this.dashboardType === "user" ? "MY_DASHBOARD" : "TEAM_DASHBOARD";
            const payload = { type, settings: JSON.stringify(settings), applyToAll: this.applyTo !== "this" };
            if (this.dashboardType === "team") {
                payload.groupId = this.getSelectedTasksFilter.groupId;
                this.applyTo = "this";
            }
            this.saveDashboardCustomization(payload).then(() => {
                this.initialDashboardItems = JSON.parse(JSON.stringify(this.dashboardItems));
            });
        },
        getDefaultCustomization(type) {
            const resetPayload = {};
            if (type === "user") {
                resetPayload.type = "MY_DASHBOARD";
            } else {
                resetPayload.type = "TEAM_DASHBOARD";
                resetPayload.groupId = this.getSelectedTasksFilter.groupId;
            }
            this.resetDashboardCustomization(resetPayload).then(() => {
                this.getCustomization(type === "user" ? "MY_DASHBOARD" : "TEAM_DASHBOARD", false, null, true);
            });
        },
        setDashboardItems(data) {
            this.dashboardItems = JSON.parse(JSON.stringify(data));
            this.dashboardCheckboxModel = [];
            this.taskCheckboxModel = [];
            this.dashboardItems.forEach(el => {
                if (el.visible) {
                    this.dashboardCheckboxModel.push(el.name);
                }
                if (el.childOptions) {
                    el.childOptions.forEach(item => {
                        if (item.visible) {
                            this.taskCheckboxModel.push(item.name);
                        }
                    });
                }
            });
        },
        updateSubtasksLogic() {
            const taskItem = this.dashboardItems.find(el => el.name === "tasks");
            if (!taskItem.childOptions[0].visible) {
                this.hideOverview = true;
                taskItem.childOptions[1].disabled = true;
            } else if (!taskItem.childOptions[1].visible) {
                this.hideTasklist = true;
                taskItem.childOptions[0].disabled = true;
            } else {
                this.hideOverview = false;
                this.hideTasklist = false;
            }
            this.tasksSuboptionsDisabled = !taskItem.visible;
        },
        cancelBehavior(event) {
            if (event) {
                this.setDashboardItems(this.initialDashboardItems);
                this.updateSubtasksLogic();
                if (this.dashboardType === "team") {
                    this.applyTo = "this";
                }
            }
        }
    }
};
